var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('SideBar'),_c('div',{staticClass:"main"},[_c('MainBar'),_c('div',{staticClass:"main-body m-4 p-3",class:{'bg-white': _vm.hasWhite}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }